import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import { format } from "date-fns";

const BeatplanForm = (props) => {
  const frmRef = useRef({});

  const dateFormat = "dd/MM/yyyy";

  const [fromSelectedDate, setFromSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  var myDate = new Date();

  myDate.setDate(myDate.getDate() + 6);

  const [toSelectedDate, setToSelectedDate] = useState(
    myDate.toISOString().substr(0, 10)
  );

  const [SelectedDate, setSelectedDate] = useState(fromSelectedDate);

  const currentDate = new Date().toISOString().slice(0, 10);

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [farmerData, setFarmerData] = useState([]);
  const [farmerListData, setFarmerListData] = useState([]);
  const [farmerSelectListData, setFarmerSelectListData] = useState([]);
  const [plotsData, setPlotsData] = useState([]);
  const [datelist, setDatelist] = useState([]);

  const [beatplanDataList, setBeatplanDataList] = useState([]);

  const activateLasers = (e) => {
    setSelectedDate(e.target.innerText);

    getFarmersData(employeeId);
    getEmployeeBeatPlanData(employeeId, e.target.innerText);
  };

  const handledropdownlistChange = (e, index) => {
    const value = e.target.value;
    farmerSelectListData[index].taskName = e.target.value;
    var newstr = farmerSelectListData;
    setFarmerSelectListData([...farmerSelectListData]);
  };

  const handleFromDateChange = (e) => {
    setFromSelectedDate(e.target.value);

    var myFDate = new Date(e.target.value);
    var myTDate = new Date(toSelectedDate);

    setSelectedDate(format(myFDate, dateFormat));

    genrateDatelist(myFDate, myTDate);
  };
  const handleToDateChange = (e) => {
    setToSelectedDate(e.target.value);
    var myFDate = new Date(fromSelectedDate);
    var myTDate = new Date(e.target.value);

    genrateDatelist(myFDate, myTDate);
  };

  const genrateDatelist = (myFDate, myTDate) => {
    var Datelst = [];
    Datelst = Datelst.concat({
      Date: format(myFDate, dateFormat),
    });
    let result = moment(myTDate).diff(myFDate, "days");

    var i = 1;
    do {
      var tempDate = new Date(myFDate);
      tempDate.setDate(tempDate.getDate() + i);

      Datelst = Datelst.concat({
        Date: format(tempDate, dateFormat),
      });

      i++;
    } while (i <= result);

    setDatelist(Datelst);
  };

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        console.log(data);

        setEmployeeData(data);
        var myFDate = new Date(fromSelectedDate);
        var myTDate = new Date(toSelectedDate);
        genrateDatelist(myFDate, myTDate);
        setSelectedDate(format(myFDate, dateFormat));
      }
    );
  }, [getEmp]);

  const { sendRequest: getplot } = useHttp();

  useEffect(() => {
    const pdata = { createdBy: employeeId };
    getplot(
      {
        url: "/api/getPlots/",
        method: "POST",
        body: pdata,
      },
      (data) => {
        setPlotsData(data.plotDetails);
      }
    );
  }, [getplot]);

  const { sendRequest: getBeatPlanData } = useHttp();

  const getEmployeeBeatPlanData = (empId, _date) => {
    const pdata = { fieldExecutiveId: empId, date: _date };

    setBeatplanDataList([]);

    getBeatPlanData(
      {
        url: "/api/getBeatPlanlist/",
        method: "POST",
        body: pdata,
      },
      (data) => {
        var beatplalist = data.beatPlanDetails.filter(
          (item) => item.date == _date
        );
        beatplalist.filter((item) => {
          if (item.timeOfTask.length > 1) {
            const timeArrray = item.timeOfTask.split(":");

            var hrs = parseInt(timeArrray[0]);

            const timeminArrray = timeArrray[1].split(" ");
            var min = timeminArrray[0];

            var ampm = timeminArrray[1];
            var hrsnew = ampm == "AM" ? hrs : hrs == 12 ? hrs : hrs + 12;
            var time =
              (hrsnew > 9 ? hrsnew.toString() : "0" + hrsnew.toString()) +
              ":" +
              min;

            item.timeOfTask = time;
          }
        });
        setBeatplanDataList(beatplalist);
        setFarmerSelectListData(beatplalist);
        var i = 0;

        do {
          var k = 0;
          do {
            if (farmerListData[k].farmerId == beatplalist[i].farmerId) {
              farmerListData[k].Iselected = true;
            }
            k++;
          } while (farmerListData.length > k);
          i++;
        } while (beatplalist.length > i);

        setFarmerListData([...farmerListData]);
      }
    );
  };

  useEffect(() => {
    getEmployeeBeatPlanData();
  }, [getBeatPlanData]);

  const { sendRequest: getFarmers } = useHttp();

  const getFarmersData = (empId) => {
    setFarmerListData([]);
    setFarmerSelectListData([]);

    const purchaseOrderUrl = `/api/beatPlanFarmer/?fieldExecutiveId=${empId}&orgId=${localStorage.getItem(
      "orgId"
    )}`;

    getFarmers(
      {
        url: purchaseOrderUrl,
      },
      (data) => {
        var listlength = data.length;
        var i = 0;
        var newList = [];
        var farmerDetails = data;

        do {
          var coordinates = '{"latitude":0.0,"longitude":0.0}';

          if (farmerDetails && farmerDetails[i].plotCorodinate) {
            var plotCorodinate = JSON.parse(farmerDetails[i].plotCorodinate);

            coordinates =
              '{"latitude":' +
              plotCorodinate[0].latitude +
              ',"longitude":' +
              plotCorodinate[0].longitude +
              "}";
          }

          var beatplanStatus = [];
          if (farmerDetails && farmerDetails[i].beatplanStatus) {
            if (farmerDetails[i].beatplanStatus.length > 0) {
              beatplanStatus = farmerDetails[i].beatplanStatus[0];
            }
          }

          var newList = newList.concat({
            linesrno: i + 1,
            farmerId: farmerDetails && farmerDetails[i].farmerId,
            farmerNo: farmerDetails && farmerDetails[i].farmerNo,
            farmerName: farmerDetails && farmerDetails[i].farmerName,
            Iselected: false,
            createdBy: parseInt(localStorage.getItem("id")),
            warehouseId: parseInt(localStorage.getItem("warehouseId")),
            coordinates: coordinates,
            olddate: beatplanStatus["date"],
            status: beatplanStatus.status,
            taskName: beatplanStatus.taskName,
            orgId: localStorage.getItem("orgId"),
          });

          i++;
        } while (listlength - 1 > i);

        setFarmerListData(newList);
        setFarmerData(data.farmerDetails);
        var newselectList = [];

        var newbealplanList = beatplanDataList;

        i = 0;

        do {
          if (newbealplanList[i].beatPlanDetails.date == SelectedDate) {
            newselectList = newselectList.concat({
              beatPlanId:
                newbealplanList &&
                newbealplanList[i].beatPlanDetails.beatPlanId,
              farmerId:
                newbealplanList && newbealplanList[i].beatPlanDetails.farmerId,
              farmerName:
                newbealplanList &&
                newbealplanList[i].beatPlanDetails.farmerName,
              coordinates:
                newbealplanList &&
                newbealplanList[i].beatPlanDetails.coordinates,
              date: newbealplanList[i].beatPlanDetails.date,
              taskId: 0,
              taskName: newbealplanList[i].beatPlanDetails.taskName,
              description: newbealplanList[i].beatPlanDetails.description,
              timeOfTask: newbealplanList[i].beatPlanDetails.description,
              createdBy: newbealplanList[i].beatPlanDetails.createdBy,
              warehouseId: newbealplanList[i].beatPlanDetails.warehouseId,
              orgId: newbealplanList[i].beatPlanDetails.orgId,
            });
          }

          i++;
        } while (newbealplanList.length > i);

        setFarmerSelectListData(newselectList);
      }
    );
  };

  useEffect(() => {
    getFarmersData();
  }, [getFarmers]);

  const handleSelect = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    var newselectList = farmerSelectListData;

    if (isChecked) {
      const now = new Date();
      var fliterlist = farmerListData.filter((item) => item.farmerId == value);
      const secondsSinceEpoch = Math.round(now.getTime() / 1000);

      newselectList = newselectList.concat({
        beatPlanId: secondsSinceEpoch,
        farmerId: value,
        farmerName: fliterlist && fliterlist[0].farmerName,
        coordinates: fliterlist && fliterlist[0].coordinates,
        date: SelectedDate,
        taskId: 0,
        taskName: "",
        description: "",
        createdBy: parseInt(localStorage.getItem("id")),
        warehouseId: parseInt(localStorage.getItem("warehouseId")),
        orgId: localStorage.getItem("orgId"),
      });

      setFarmerSelectListData(newselectList);
    } else {
      newselectList = newselectList.filter((item) => item.farmerId !== value);
      setFarmerSelectListData(newselectList);
    }
  };

  const { sendRequest: posteatplan } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    var newfinalList = [];
    var i = 0;

    if (farmerSelectListData.length > 0) {
      do {
        var time = "";

        if (farmerSelectListData[i].timeOfTask.length > 1) {
          const timeArrray = farmerSelectListData[i].timeOfTask.split(":");

          var hrs = parseInt(timeArrray[0]);
          var min = timeArrray[1];
          var ampm = hrs < 12 ? "AM" : "PM";
          var hrsnew = hrs % 12 || 12;
          time =
            (hrsnew > 9 ? hrsnew.toString() : "0" + hrsnew.toString()) +
            ":" +
            min +
            " " +
            ampm;
        }

        var newfinalList = newfinalList.concat({
          farmerId: farmerSelectListData[i].farmerId,
          timeOfTask: farmerSelectListData[i].timeOfTask,
          fieldExecutiveId: employeeId,
          taskName: farmerSelectListData[i].taskName,
          farmerName: farmerSelectListData[i].farmerName,
          description: farmerSelectListData[i].description,
          timeOfTask: time,
          coordinates: farmerSelectListData[i].coordinates,
          status: 0,
          date: farmerSelectListData[i].date,

          beatPlanId: farmerSelectListData[i].beatPlanId,
        });
        i++;
      } while (farmerSelectListData.length > i);
    }
    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      beatPlanDetails: newfinalList,
    };

    posteatplan(
      {
        url: "/api/addBeatPlan/",

        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Beat plan detail added.`);
      }
    );
  };

  const bindBeatplanDate = (event, itemIndex) => {
    var Newlist = farmerSelectListData;

    Newlist[itemIndex].date = moment
      .utc(event.target.value)
      .toISOString()
      .substr(0, 10);

    setFarmerSelectListData(Newlist);
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <div className="container-fluid">
            {/* SELECT2 EXAMPLE */}
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title"> Beatplan Details</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Procurement Officer</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                          getFarmersData(e.target.value);
                          getEmployeeBeatPlanData(e.target.value, SelectedDate);
                        }}
                      >
                        <option>--Select--</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option
                              key={x.userId}
                              user-id={x.userId}
                              value={x.userId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>From Date </label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        min={currentDate}
                        value={fromSelectedDate}
                        onChange={handleFromDateChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>To Date</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        min={currentDate}
                        value={toSelectedDate}
                        onChange={handleToDateChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-4"></div>
                  <div className="col-md-4"></div>
                </div>
                <div className="row">
                  <div className="col-md-3"> </div>
                  <div className="col-md-9">
                    <table className="table  table-responsive text-center table-sm">
                      <thead>
                        {datelist &&
                          datelist.map((itm, i) => {
                            return (
                              <th key={i}>
                                <button
                                  className="btn  btn-primary mx-2 my-2"
                                  type="submit"
                                  onClick={activateLasers}
                                >
                                  {itm.Date}
                                </button>
                              </th>
                            );
                          })}
                      </thead>
                    </table>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <table
                      className="table table-bordered table-responsive text-center table-sm"
                      style={{ height: "400px", width: "90%" }}
                    >
                      <th>Farmer Name</th>

                      {farmerListData &&
                        farmerListData.map((itm, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <div>
                                  <div
                                    className="flexRow"
                                    style={{ textAlign: "left" }}
                                  >
                                    <b> Name: </b>
                                    {itm.farmerName} &nbsp;
                                    <input
                                      type="checkbox"
                                      name="languages"
                                      value={itm.farmerId}
                                      defaultChecked={itm.Iselected}
                                      onChange={handleSelect}
                                    />
                                  </div>

                                  <div
                                    className="flexRowSmallFont"
                                    style={{ textAlign: "left" }}
                                  >
                                    <b> No: </b>
                                    {itm.farmerNo}{" "}
                                  </div>
                                  <div
                                    className="flexRowSmallFont"
                                    style={{ textAlign: "left" }}
                                  >
                                    <b> Last Task Date: </b>
                                    {itm.olddate}
                                  </div>
                                  <div
                                    className="flexRowSmallFont"
                                    style={{ textAlign: "left" }}
                                  >
                                    <b> Last Task : </b>
                                    {itm.taskName}
                                  </div>
                                  <div
                                    className="flexRowSmallFont"
                                    style={{ textAlign: "left" }}
                                  >
                                    <b> Task Status:</b> {itm.status}
                                  </div>
                                </div>

                                <div
                                  className="flexRow"
                                  style={{
                                    background: "fray",
                                    height: "3px",
                                    padding: "10px",
                                  }}
                                >
                                  &nbsp;{" "}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </table>
                  </div>
                  <div className="col-md-9">
                    <table
                      className="table table-bordered table-responsive text-center table-sm"
                      style={{ width: "99%" }}
                    >
                      <thead>
                        <tr className="tableheaderrowview">
                          <th>Farmer Name</th>
                          <th>Task Date </th>

                          <th>Task </th>
                          <th>Description </th>
                          <th>Time </th>
                          <th>Task Status </th>
                        </tr>
                      </thead>
                      <tbody>
                        {farmerSelectListData &&
                          farmerSelectListData.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.farmerName}</td>
                                <td>{itm.date}</td>

                                <td>
                                  {
                                    <select
                                      id="assign_task"
                                      className="inputs dropdowns"
                                      ref={(el) =>
                                        (frmRef.current["emp_id"] = el)
                                      }
                                      value={farmerSelectListData[i].taskName}
                                      onChange={(e) =>
                                        handledropdownlistChange(e, i)
                                      }
                                    >
                                      <option>--Select--</option>
                                      <option value="Prospecting">
                                        Prospecting
                                      </option>
                                      <option value="Follow-up Visit">
                                        Follow-up Visit
                                      </option>
                                      {/* <option>Farmer Registration</option> */}
                                      <option value="Farmer Meeting">
                                        {" "}
                                        Farmer Meeting
                                      </option>
                                      <option value="Farmer Deal">
                                        Farmer Deal{" "}
                                      </option>
                                      <option value="Farmer Goods Issue">
                                        Farmer Goods Issue
                                      </option>
                                      <option value="Yield Estimation">
                                        {" "}
                                        Yield Estimation
                                      </option>
                                      <option value="Sample Collection">
                                        Sample Collection
                                      </option>
                                      <option value="MRL Test">
                                        {" "}
                                        MRL Test
                                      </option>
                                      <option value="Field QC">
                                        Field QC{" "}
                                      </option>
                                      <option value="Procurement">
                                        Procurement
                                      </option>
                                      <option value="Farmer Payment">
                                        Farmer Payment
                                      </option>
                                      <option value="Observations">
                                        Observations
                                      </option>
                                    </select>
                                  }
                                </td>
                                <td>
                                  {" "}
                                  <input
                                    type={"text"}
                                    id={"description"}
                                    required
                                    ref={(el) =>
                                      (frmRef.current["description"] = el)
                                    }
                                    className="inputs"
                                    defaultValue={
                                      farmerSelectListData[i].description
                                    }
                                    onChange={(e) => {
                                      farmerSelectListData[i].description =
                                        e.target.value;
                                      setFarmerSelectListData(
                                        farmerSelectListData
                                      );
                                    }}
                                  />
                                </td>

                                <td>
                                  <input
                                    type={"time"}
                                    id={"packingTime"}
                                    required
                                    ref={(el) =>
                                      (frmRef.current["timeOfTask"] = el)
                                    }
                                    className="inputs"
                                    defaultValue={
                                      farmerSelectListData[i].timeOfTask
                                    }
                                    onChange={(e) => {
                                      farmerSelectListData[i].timeOfTask =
                                        e.target.value;
                                      setFarmerSelectListData(
                                        farmerSelectListData
                                      );
                                    }}
                                  />
                                </td>
                                <td>
                                  {farmerSelectListData[i].Status == 1
                                    ? "Completed"
                                    : "Pending"}{" "}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-1">
                    <form style={{ margin: "10px" }} onSubmit={submitHandler}>
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Submit
                      </button>
                    </form>
                  </div>
                  <div className="col-md-1">
                    {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                  </div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-4"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BeatplanForm;
